import {Button, Typography} from 'onboarding-components';
import * as React from 'react';
import produce from 'immer';

import {SetupGuideContext, Step} from 'common/onboarding/immersive-onboarding/types';
import {IMMERSIVE_ASSETS} from 'common/onboarding/immersive-onboarding/assets';
import {track, TrackingEvent, TrackingProperty} from 'common/onboarding/immersive-onboarding/tracking';
import {ApiClient} from 'common/onboarding/immersive-onboarding/api-client';

import {FooterActionBar} from './footer-action-bar';
import styles from './welcome-v2.module.styl';

// eslint-disable-next-line react/destructuring-assignment
const WelcomeCTA = ({image, title, subtitle, cta, iconSrc}) => {
  const {onClick, ctaText} = cta;
  return (
    <>
      <div
        className={styles.welcomeCta}
        style={{
          backgroundImage: `url(${image})`,
          backgroundSize: `cover`,
          backgroundRepeat: `no-repeat`,
        }}
      >
        <img src={iconSrc} className={styles.welcomeCtaIcon} />
        <div className={styles.welcomeCtaContent}>
          <Typography variant='headingXs' className={styles.noMargin}>
            {title}
          </Typography>
          <Typography variant='bodySm'>{subtitle}</Typography>
          <div>
            <Button variant='solid' size='medium' onClick={onClick}>
              {ctaText}
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export const WelcomeV2Default = () => {
  const {setStep, setupGuideInfo, setSetupGuideInfo} = React.useContext(SetupGuideContext);

  return (
    <div className={styles.welcomeContent}>
      <Typography variant='headingSm' className={styles.noMargin}>{`Choose how you would like to start`}</Typography>
      <Typography className={styles.subTitle} variant='bodySm'>
        {`Mixpanel will help you better understand your customers and answer questions about your product`}
      </Typography>
      <div className={styles.welcomeCtas}>
        <WelcomeCTA
          image={IMMERSIVE_ASSETS.personalizeStepGradient}
          title={`I'm new to product analytics`}
          subtitle={`Mixpanel will walk you through a quick setup to track and connect data`}
          cta={{
            ctaText: `Personalize Setup`,
            onClick: () => {
              // TODO (Sonya) - distill this to one function
              const updatedStepsCompleted = produce(setupGuideInfo.stepsCompleted, (draft) => {
                draft.add(Step.Welcome);
              });
              ApiClient.updateCompleted(setupGuideInfo.projectId, updatedStepsCompleted);
              setSetupGuideInfo({...setupGuideInfo, stepsCompleted: updatedStepsCompleted});

              setStep(Step.Events);

              track(TrackingEvent.WelcomePersonalizeSetupClick, {
                [TrackingProperty.CurrentStep]: Step.Welcome,
                [TrackingProperty.Phase2]: true,
              });
            },
          }}
          iconSrc={IMMERSIVE_ASSETS.clipboardCheckboxes}
        />
        <WelcomeCTA
          image={IMMERSIVE_ASSETS.connectDataGradient}
          title={`I already collect data in a tool`}
          subtitle={`Such as Segment, Snowflake, BigQuery, Redshift, Rudderstack, etc...`}
          cta={{
            ctaText: `Connect Data`,
            onClick: () => {
              const updatedStepsCompleted = produce(setupGuideInfo.stepsCompleted, (draft) => {
                draft.add(Step.Welcome);
              });
              ApiClient.updateCompleted(setupGuideInfo.projectId, updatedStepsCompleted);
              setSetupGuideInfo({...setupGuideInfo, stepsCompleted: updatedStepsCompleted});

              setStep(Step.Implement);
              track(TrackingEvent.WelcomeConnectDataClick, {
                [TrackingProperty.CurrentStep]: Step.Welcome,
                [TrackingProperty.Phase2]: true,
              });
            },
          }}
          iconSrc={IMMERSIVE_ASSETS.ligthningBolt}
        />
      </div>
      <div className={styles.footerActionBarWrapper}>
        <FooterActionBar />
      </div>
    </div>
  );
};
